<template>
	<div class="p-product-personal">
    <div class="banner">
      <a class="inner" href="//wpa.qq.com/msgrd?v=3&uin=1685607977&menu=yes" target="_blank">
        <img width="1010" src="/image/product/personal/banner.png"/>
      </a>
    </div>
    <div class="part t1">
      <img src="/image/product/personal/1.png"/>
    </div>
    <div class="part t2">
      <div class="content">
        <img src="/image/product/personal/2.png"/>
      </div>
    </div>
    <div class="part t3">
      <div class="content">
        <img src="/image/product/personal/31.png"/>
        <!-- <img src="/image/product/personal/32.png"/> -->
      </div>
    </div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          title: "健康管理公司",
          desc:
            "体重管理公司\n健身房\n美容院\n月子中心\n健康培训机构\n高校营养与食品专业\n...",
          img: "/image/product/personal/11.jpg",
        },
        {
          title: "医疗卫生服务机构",
          desc: "社区卫生服务中心站\n医院营养科\n健康体检中心\n养老机构\n...",
          img: "/image/product/personal/12.jpg",
        },
      ],
      tab: {
        index: 0,
        list: ["客户管理落后", "营养管理缺乏", "经营方式落后"],
      },
    };
  },
};
</script>

<style lang="less">
.p-product-personal {
  > .banner {
    width: 100%;
    height: 450px;
    display: flex;
    align-items: center;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    background-image: url("/image/product/personal/banner-bg.jpg");
    > .inner {
      width: 1010px;
      display: block;
      color: #ffffff;
      margin: 0px auto;
    }
  }
  > .part {
    &.t1 {
      padding-top: 80px;
    }
    &.t2 {
      position: relative;
      background-size: contain;
      background-position: 50%;
      background-repeat: no-repeat;
      background-image: url("/image/product/personal/2-bg.png");
      &::before {
        content: "";
        display: block;
        padding-top: 53.367%;
      }
      > .content {
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        position: absolute;
        > img {
          width: 1010px;
          display: block;
          margin: 15% auto auto;
        }
      }
    }
    &.t3 {
      // margin-top: 240px;
      height: 450px;
      position: relative;
      background-size: cover;
      background-position-y: 100px;
      background-repeat: no-repeat;
      background-image: url("/image/product/personal/3-bg.png");
      &::before {
        content: "";
        display: block;
        padding-top: 63.25%;
      }
      > .content {
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        position: absolute;
        > img {
          width: 1010px;
          display: block;
          &:nth-child(1) {
            margin: -80px auto auto;
          }
          &:nth-child(2) {
            margin: 100px auto auto;
          }
        }
      }
    }
    > img {
      width: 1010px;
      display: block;
      margin: 0px auto;
    }
  }
}
</style>